import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/payroll-actions';
import { PayrollActions } from '../constants';
import { IPayroll } from 'src/types/payroll';
import { IProvider } from 'src/types/provider';

export interface PayrollState {
    inProgress: boolean;
    inProgressEntity: boolean;
    authCode: string;
    error: string;
    data: Paginated<IPayroll>;
    dataEntities: {
        list?: any;
    };
    providerPayload: Paginated<Partial<IProvider>>;
    current: IPayroll | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    inProgressEntity: false,
    authCode: '',
    error: '',
    dataEntities: { list: [] },
    providerPayload: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    data: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },

    current: null,
    currentFiles: null,
};

export function payrolls(state: PayrollState = initialState, action: Actions | any): PayrollState {
    switch (action.type) {
        case requestType(PayrollActions.PERSIST_PAYROLL):
            return { ...state, error: '', inProgress: true };
        case successType(PayrollActions.PERSIST_PAYROLL):
            return { ...state, inProgress: false };
        case failureType(PayrollActions.PERSIST_PAYROLL):
            return { ...state, error: action.error, inProgress: false };
        case requestType(PayrollActions.FETCH_PAYROLLS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                            updatedAt: null,
                        },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(PayrollActions.FETCH_PAYROLLS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(PayrollActions.FETCH_PAYROLLS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };
        case requestType(PayrollActions.FETCH_PAYROLLS_IN_FILE):
            return {
                ...state,
                error: '',
                inProgress: true,
            };
        case successType(PayrollActions.FETCH_PAYROLLS_IN_FILE):
            return { ...state, inProgress: false };
        case failureType(PayrollActions.FETCH_PAYROLLS_IN_FILE):
            return { ...state, error: action.error, inProgress: false };

        case requestType(PayrollActions.FETCH_PAYROLLS_PROVIDERS):
            return {
                ...state,
                inProgress: true,
                providerPayload: { ...state.providerPayload, inProgress: true },
            };
        case successType(PayrollActions.FETCH_PAYROLLS_PROVIDERS):
            return {
                ...state,
                providerPayload: { ...state.providerPayload, list: Object.values(action.payload), inProgress: false },
                error: '',
                inProgress: false,
            };
        case failureType(PayrollActions.FETCH_PAYROLLS_PROVIDERS):
            return {
                ...state,
                error: '',
                inProgress: false,
                providerPayload: { ...state.providerPayload, inProgress: false },
            };

        case requestType(PayrollActions.FETCH_PAYROLL):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(PayrollActions.FETCH_PAYROLL):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(PayrollActions.FETCH_PAYROLL):
            return { ...state, inProgress: false, error: action.error };

        case requestType(PayrollActions.FETCH_PAYROLLS_ENTITIES):
            return { ...state, inProgressEntity: true, inProgress: true, dataEntities: { list: [] }, error: '' };
        case successType(PayrollActions.FETCH_PAYROLLS_ENTITIES):
            return {
                ...state,
                inProgressEntity: false,
                inProgress: false,
                dataEntities: { list: action.payload },
            };
        case failureType(PayrollActions.FETCH_PAYROLLS_ENTITIES):
            return { ...state, inProgressEntity: false, inProgress: false, error: action.error };

        case requestType(PayrollActions.DELETE_PAYROLL):
            return { ...state, error: '', inProgress: true };
        case successType(PayrollActions.DELETE_PAYROLL):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IPayroll) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(PayrollActions.DELETE_PAYROLL):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case requestType(PayrollActions.UPDATE_PAYROLL):
            return { ...state, error: '', inProgress: true };
        case successType(PayrollActions.UPDATE_PAYROLL):
            state.data.list.forEach((payroll: IPayroll, k, array) => {
                if (payroll.id === action.payload.id) {
                    array[k] = { ...array[k], status: action.payload.status };
                }
            });
            return {
                ...state,
                data: {
                    ...state.data,
                    list: state.data.list,
                    meta: state.data.meta,
                },
                current: state.current ? { ...state.current, status: action.payload.status } : null,
                inProgress: false,
            };
        case failureType(PayrollActions.UPDATE_PAYROLL):
            return {
                ...state,
                error: action.error?.response?.data?.errorMessage ?? 'Unknown error',

                inProgress: false,
            };

        default:
            return state;
    }
}
